import moment from 'moment';
import { WorkdayModel } from '../../models/low-level/workday.model';
import { WeeklyWorkdayModel } from './utils/weekly-work-time';

/**
 * One derived day as the legacy `WorkdayModel` callers still expect: `committedInHours` becomes
 * `submittedTimesheetDuration` and `inProgressInHours` becomes `currentTimesheetDuration`. The only
 * place in the weekly-work-time migration that touches the legacy model class — the selectors and
 * the NgRx service itself stay model-free.
 *
 * @param workday the derived day
 */
export function weeklyWorkdayToModel(workday: WeeklyWorkdayModel): WorkdayModel {
    return new WorkdayModel(
        workday.workDate,
        moment.duration(workday.inProgressInHours, 'hours'),
        moment.duration(workday.committedInHours, 'hours'),
    );
}

/**
 * {@link weeklyWorkdayToModel} for a whole week.
 *
 * @param workdays the derived days, Monday first
 */
export function weeklyWorkdaysToModels(workdays: readonly WeeklyWorkdayModel[]): WorkdayModel[] {
    return workdays.map(weeklyWorkdayToModel);
}
